import { useQuery } from "react-query";
import { CheckAlertsApi } from "../api/checkAlerts.api";
import { CheckAlertsDto } from "../components/Alerts/AlertsList/entities.typings";

export const useGetCheckAlertsById = (id: number, enabled: boolean) =>
  useQuery<CheckAlertsDto>(["checkAlerts", { id }], () => CheckAlertsApi.getCheckAlertsById(id).then((res) => res), {
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
